module.exports = __webpack_public_path__ + "img/IEC30444.b55fdb79.png";